import React from 'react'
import { connect } from 'react-redux'
import { Switch, Route } from 'react-router-dom'
import { setHeader } from '../actions'
import DocumentList from '../components/DocumentList'
import DocumentDetail from '../components/DocumentDetail'
import DocumentForm from '../components/DocumentForm'

const Document = ({ documents, setHeader }) => (
  documents?
    <div className="document content">
      <Switch>
        <Route exact path='/document' render={() => <DocumentList documents={documents} setHeader={setHeader} />} />
        <Route exact path='/document/new' render={() => <DocumentForm documents={documents} setHeader={setHeader} />} />
        <Route path='/document/edit/:id' render={() => <DocumentForm documents={documents} setHeader={setHeader} />} />
        <Route path='/document/:id' render={() => <DocumentDetail documents={documents} setHeader={setHeader} />} />
      </Switch>
    </div>
  :
    <div>Loading...</div>
)
export default connect(
  state => ({ documents: state.documents }),
  { setHeader }
)(Document)


// WEBPACK FOOTER //
// ./src/containers/Document.js